<template>
    <div class="font-inter w- h-[1040px] bg-[#FFFFFF] rounded-t-[20px] mt-3">
      <HeaderComponent page-title="Project Assets" />
      <div v-if="project.project_id" class="font-inter">
        <div class=" ">
          <div class="border-grayLight border-b-[1px] h-auto justify-between bg-white px-8 text-grayDark rounded">
            <div class="flex justify-between my-6">
              <!-- <div class="px-8 space-y- rounded mt-8" v-if="viewMode === 'list'">
                <ProjectsAssetsStatus/>
              </div> -->
                <div class="flex items-center gap-3 mb-4">
                  <div class="flex items-center">
                    <input v-if="editingName" v-model="projectName" @blur="saveProjectName" @keyup.enter="saveProjectName" type="text" class="text-2xl font-bold border border-gray-300 rounded p-2"/>
                    <h1 v-else  class="text-[20px] font-bold text-bodyText cursor-pointer" @click="enableEditName">
                      {{ project.project_name }} - Assets
                    </h1>
                  </div>
                </div>
            </div>
            <div class="px-8 space-y- rounded mb-8" v-if="viewMode === 'list'">
            <!-- <TaskTable /> -->
            <ProjectsAssetsStatus />
          </div>
          </div>
  
          <div class="px-8 space-y- rounded mt-8" v-if="viewMode === 'list'">
            <ContributorsTable />
          </div>
        </div>
      </div>    
    </div>
  
  </template>
  
  <script>
    import apiClient from '@/axios';
    import HeaderComponent from '@/components/HeaderComponent.vue';
    import eventBus from '@/eventBus';
    import ProjectsAssetsStatus from './ProjectsAssetsStatus.vue';
    import ContributorsTable from './ContributorsTable.vue';
  
    export default {
      name: 'ProjectDetailsComponent',
      components: {
        HeaderComponent,
        ProjectsAssetsStatus,
        ContributorsTable,
      },
      data() {
        return {
          viewMode: 'list',
          isSideMenuOpen: false,
          project: {
            start_date: '',
            end_date: '',
            project_id: '',
            project_name: '',
            description: '',
          },
          member: {
            project_member_id: '',
            project_id: '',
            talent_id: '',
            position: '',
            talent_user_id: '',
          },
          // managerDetails: {
          //   first_name: '',
          //   last_name: '',
          //   email: ''
          // },
          projectName: '', 
          projectDescription: '',
          tasks: [],
          statuses: ["All", "In Progress", "Completed", "Not Started"],
          selectedStatus: "All",
          talents: [], // Load assignee options
          selectedAssignee: null, // Store the selected assignee
          selectedDateRange: { start: null, end: null }, // New property for date filtering
          showAssigneeDropdown: false,
          showStatusDropdown: false,
          // talents: [],
  
          members:[],
          showTaskModal: false,
          showAddMemberModal: false,
          showCreateTaskModal: false,
          editingName: false,
          editingDescription: false,
        };
      },
  
      computed: {
        isAdmin() {
          return this.$store.getters.isAdmin;
        },
        isManager() {
          return this.$store.getters.isManager;
        },
        isTalent() {
          return this.$store.getters.isTalent;
        },
      },
      methods: {
        toggleStatusDropdown() {
          this.showStatusDropdown = !this.showStatusDropdown;
        },
        // setStatusFilter(status) {
        //   this.selectedStatus = status;
        //   this.showStatusDropdown = false;
        // },
        setStatusFilter(task_status) {
        this.selectedStatus = task_status;
        this.showStatusDropdown = false;
        console.log("Selected task status updated to:", this.selectedStatus); // Debugging
      },
      toggleAssigneeDropdown() {
      this.showAssigneeDropdown = !this.showAssigneeDropdown;
    },
    setAssigneeFilter(assignee) {
    this.filters = {
      ...this.filters,
      assignee: assignee ? assignee.talent_user_id : null,
    };
    this.selectedAssignee = assignee; // Update the dropdown label
    this.showAssigneeDropdown = false;
  },
    applyFilters() {
      console.log("Applying Filters:", this.filters);
    },
        // filteredTasks() {
        //   if (this.selectedStatus === "All") {
        //     return this.tasks; // Show all tasks
        //   }
        //   return this.tasks.filter((task) => task.status === this.selectedStatus);
        // },
        openSideMenu(member) {
          this.selectedMember = member; // Set the selected task
          this.isSideMenuOpen = true; // Open the side menu
        },
          closeSideMenu() {
          this.isSideMenuOpen = false; // Close the side menu
          this.selectedReport = null; // Clear the selected task
        },
        setViewMode(mode) {
          this.viewMode = mode;
        },
      emitOpenAddProjectMemberModal() {
        eventBus.emit('openAddProjectMemberModal')
      },
      removeMember(index) {
        this.members.splice(index, 1); // Remove the member at the specified index
      },
      formatDate(dateString) {
        if (!dateString) return '';
        const date = new Date(dateString);
        const month = date.getMonth() + 1; // Months are zero-based
        const day = date.getDate();
        return `${month}/${day}`;
      },
      
      async fetchProject() {
        const projectId = this.$route.params.projectId;
        try {
          const response = await apiClient.get(`/web/projects/${projectId}`);
          this.project = response.data.data;
          this.projectName = this.project.project_name;
  
          // if (this.project.manager_id) {
          //   this.fetchManagerDetails(this.project.manager_id);
          // }
  
          this.fetchTasks(projectId);
          this.fetchProjectMembers(projectId);
  
        } catch (error) {
          if (error.response && error.response.status === 404) {
            // Redirect to 404 page if not found
            this.$router.push({ name: 'NotFound' });
          } else {
            console.error('Error fetching project data:', error);
          }
        }
      },
  
      // async fetchManagerDetails(managerId) {
      //   try {
      //     const response = await apiClient.get(`/web/managers/${managerId}`);
      //     console.log('Manager Details Response:', response.data); // Log the response to inspect it
      //     this.managerDetails = response.data.data; 
      //   } catch (error) {
      //     console.error('Error fetching manager details:', error);
      //   }
      // },
  
  
        enableEditName() {
          this.projectName = this.project.project_name;
          this.editingName = true;
        },
        enableEditDescription() {
          this.projectDescription = this.project.description;
          this.editingDescription = true;
        },
    
  
        async saveProjectName() {
          this.editingName = false;
          try {
            // Prepare the payload for the PATCH request
            const payload = {
              project_name: this.projectName,
              start_date: this.project.start_date,
              end_date: this.project.end_date,
              status: this.project.status,
              description: this.project.description,
            };
            
            // Send the PATCH request to update the project
            await apiClient.patch(`/web/projects/${this.project.project_id}`, payload);
  
            // Update the local project object with the new name
            this.project.project_name = this.projectName;
  
            this.$toast.success('Project name updated successfully!');
          } catch (error) {
            console.error('Error updating project name:', error);
          }
        },
  
        async saveProjectDescription() {
          this.editingDescription = false;
          try {
            // Prepare the payload for the PATCH request
            const payload = {
              project_name: this.project.project_name, // Keep the project name
              start_date: this.project.start_date, // Include other required fields
              end_date: this.project.end_date,
              status: this.project.status,
              description: this.projectDescription, // Send the edited project description
            };
  
            // Send the PATCH request to update the description
            await apiClient.patch(`/web/projects/${this.project.project_id}`, payload);
  
            // Update the local project object with the new description
            this.project.description = this.projectDescription;
  
            this.$toast.success('Project description updated successfully!');
          } catch (error) {
            console.error('Error updating project description:', error);
          }
        },
  
  
        async updateDate(field) {
          try {
            // Construct payload with the current project state, only including the necessary fields
            const payload = {
              project_name: this.project.project_name,
              start_date: this.project.start_date,
              end_date: this.project.end_date,
              status: this.project.status,
              description: this.project.description,
              [field]: this.project[field],             // Field being updated (start_date or end_date)
            };
  
            // Send the PATCH request with the full payload
            await apiClient.patch(`/web/projects/${this.project.project_id}`, payload);
  
            // Display success message
            this.$toast.success(`${field.replace('_', ' ')} updated successfully!`);
  
          } catch (error) {
            this.$toast.error(`Failed to update ${field.replace('_', ' ')}`);
            console.error(`Error updating ${field}:`, error);
            console.error('Error updating project:', error.response ? error.response.data : error);
          }
        },
  
        handleTaskCreated(message) {
          this.$toast.success(message);
  
          // Refresh the task list
          this.fetchTasks(this.project.project_id);
      },
  
        async fetchTasks(projectId) {
          try {
            const response = await apiClient.get(`/web/projects/${projectId}/tasks`);
            this.tasks = response.data.data;
          } catch (error) {
            console.error('Error fetching tasks data:', error);
          }
        },
        async fetchProjectMembers(projectId) {
          try {
            const response = await apiClient.get(`/web/projects/${projectId}/project_members/`);
            this.members = response.data.data;
          } catch (error) {
            console.error('Error fetching members data:', error);
          }
        },
        async fetchTalents() {
          try {
            const response = await apiClient.get('/web/talents', {
              params: { page_size: 100, project_id: this.project.project_id }
            });
            this.talents = response.data.data;
          } catch (error) {
            console.error('Error fetching talents:', error);
          }
        },
        clearErrorMessage() {
          console.log("Legacy: Clearing error message in parent component");
        },
  
        openCreateTaskModal() {
          this.showCreateTaskModal = true;
          if (this.$refs.createTaskModal) {
            this.$refs.createTasktModal.clearErrorMessage(); // Use the ref to call the method
          }
        },
        closeCreateTaskModal() {
          this.showCreateTaskModal = false;
        },
        openAddMemberModal() {
          this.showAddMemberModal = true;
        },
        closeAddMemberModal() {
          this.showAddMemberModal = false;
        },
        handleMemberAddedSuccess(message) {
          this.showAddProjectMemberModal = false; // Close the modal
          this.$toast.success(message);
  
          this.fetchProjectMembers(this.project.project_id); // Refresh the member list
        },
  
        handleTaskError(message) {
            this.$toast.error(message);
          },
        closeTaskModal() {
            // Reset the error state and close the modal
            this.showTaskModal = false;
          },

        goToProgressReports(projectName) {
          if (!projectName) {
            console.error('Project name is undefined.');
            return;
          }
          // Use Vue Router to navigate to the Progress Reports page for this project
          this.$router.push({ name: 'ProgressReports', params: { projectName } });
        },
        goToProjectActivities(projectId) {
          this.$router.push({ name: 'ActivityData', params: { projectId } });
        },  
  
      },
      created() {
        const projectId = this.$route.params.projectId;
  
        this.fetchProject();
        this.fetchTalents();      
        this.fetchProjectMembers(projectId); // Fetch project members
  
      }
    }
  </script>
  
  <style scoped>
  .smoke-light {
    background-color: rgba(0, 0, 0, 0.5);
  }
  </style>
  